export const isKPMG = (employerName: string = '') =>
  employerName.includes('KPMG');
